// extracted by mini-css-extract-plugin
module.exports = {"light":"App_light__2LgeT","dark":"App_dark__1a8eo"};